import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import { ThemeContext } from 'src/store/ContextStore';

const Line1 = styled(Typography)({
  fontSize: '1.25rem',
  fontWeight: 'bold'
});

const Line2 = styled(Typography)({
  fontSize: '1rem'
});

const Line3 = styled(Typography)({
  fontSize: '1rem'
});

const joinParts = (...parts) => parts.filter(Boolean).join(', ');

const ModalHeader = ({ title, personSummary }) => {
  const { theme } = useContext(ThemeContext);

  const { idPart, namePart, dobPart, hospitalPart, healthcarePart } =
    (typeof personSummary === 'function' ? personSummary() : personSummary) ||
    {};

  const formattedDOBPart = dobPart
    ? moment(dobPart).format(theme.dateFormat)
    : '';

  return (
    <div>
      <Line1>{title}</Line1>

      {idPart || namePart || dobPart ? (
        <Line2>{joinParts(idPart, namePart, formattedDOBPart)}</Line2>
      ) : null}

      {hospitalPart || healthcarePart ? (
        <Line3>{joinParts(hospitalPart, healthcarePart)}</Line3>
      ) : null}
    </div>
  );
};

export default ModalHeader;
